export enum UserPermissions {
  users_read_bank = 'users.read.bank',
  users_create_bank = 'users.create.bank',
  users_update_bank = 'users.update.bank',
  users_delete_bank = 'users.delete.bank',
  users_read_provider = 'users.read.provider',
  users_create_provider = 'users.create.provider',
  users_update_provider = 'users.update.provider',
  users_delete_provider = 'users.delete.provider',

  reports_read_bank = 'reports.read.bank',
  reports_reject_bank = 'reports.reject.bank',
  reports_review_bank = 'reports.review.bank',
  reports_approve_bank = 'reports.approve.bank',
  reports_read_provider = 'reports.read.provider',
  reports_review_provider = 'reports.review.provider',
  reports_read_inprogress_bank = 'reports.read.inprogress.bank',

  inspectors_read_bank = 'inspectors.read.bank',
  inspectors_create_bank = 'inspectors.create.bank',
  inspectors_update_bank = 'inspectors.update.bank',
  inspectors_delete_bank = 'inspectors.delete.bank',
  inspectors_read_provider = 'inspectors.read.provider',
  inspectors_create_provider = 'inspectors.create.provider',
  inspectors_update_provider = 'inspectors.update.provider',
  inspectors_activate_provider = 'inspectors.activate.provider',
  inspectors_deactivate_provider = 'inspectors.deactivate.provider',

  inspections_read_bank = 'inspections.read.bank',
  inspections_create_bank = 'inspections.create.bank',
  inspections_update_bank = 'inspections.update.bank',
  inspections_cancel_bank = 'inspections.cancel.bank',
  inspections_delete_bank = 'inspections.delete.bank',
  inspections_schedule_bank = 'inspections.schedule.bank',
  inspections_read_inspector = 'inspections.read.inspector',
  inspections_refuse_inspector = 'inspections.refuse.inspector',
  inspections_schedule_inspector = 'inspections.schedule.inspector',
  inspections_read_provider = 'inspections.read.provider',
  inspections_track_provider = 'inspections.track.provider',
  inspections_update_provider = 'inspections.update.provider',
  inspections_refuse_provider = 'inspections.refuse.provider',
  inspections_redirect_provider = 'inspections.redirect.provider',
  inspections_schedule_provider = 'inspections.schedule.provider',

  data_edit_bank = 'data.edit.bank',
  data_export_bank = 'data.export.bank',

  checklist_read_bank = 'checklist.read.bank',
  checklist_create_bank = 'checklist.create.bank',
  checklist_update_bank = 'checklist.update.bank',
  checklist_delete_bank = 'checklist.delete.bank',
  checklist_read_provider = 'checklist.read.provider',
  checklist_read_inspector = 'checklist.read.inspector',
  checklist_fill_inspector = 'checklist.fill.inspector',
  checklist_review_provider = 'checklist.review.provider',

  expenses_read_bank = 'expenses.read.bank',
  expenses_approve_bank = 'expenses.approve.bank',
  expenses_read_provider = 'expenses.read.provider',
  expenses_read_inspector = 'expenses.read.inspector',
  expenses_create_provider = 'expenses.create.provider',
  expenses_suggest_inspector = 'expenses.suggest.inspector',

  providers_read_bank = 'providers.read.bank',
  providers_create_bank = 'providers.create.bank',
  providers_update_bank = 'providers.update.bank',
  providers_delete_bank = 'providers.delete.bank',

  settings_read_bank = 'settings.read.bank',
  settings_create_bank = 'settings.create.bank',
  settings_update_bank = 'settings.update.bank',
  settings_delete_bank = 'settings.delete.bank',

  documents_edit_bank = 'documents.edit.bank',
  documents_read_bank = 'documents.read.bank',

  attachments_read_inspector = 'attachments.read.inspector',
  attachments_insert_inspector = 'attachments.insert.inspector',

  schedules_read_bank = 'schedules.read.bank',
  schedules_update_bank = 'schedules.update.bank',

  logs_read_bank = 'logs.read.bank',
  audit_read_bank = 'audit.read.bank',

  inspections_accept_provider = 'inspections.accept.provider',
  inspections_accept_inspector = 'inspections.accept.inspector',
  inspections_reject_provider = 'inspections.reject.provider',
  inspections_reject_inspector = 'inspections.reject.inspector',
  inspections_address_edit = 'inspections.address.edit',
  inspections_redirect_inspector = 'inspections.redirect.inspector',
  
  reports_finalized_review = 'reports.finalized.review',
  reports_progress_review = 'reports.progress.review',
  users_edit_bank = 'users.edit.bank',
  users_edit_provider = 'users.edit.provider',
  
  checklist_create_provider = 'checklist.create.provider',
  checklist_update_provider = 'checklist.update.provider',
  checklist_delete_provider = 'checklist.delete.provider',
  
  dashboard_view = 'dashboard.view',
  dashboard_view_provider = 'dashboard.view.provider',
  home_view = 'home.view',
  home_view_provider = 'home.view.provider',
  home_view_inspector = 'home.view.inspector',

  parametrization_read_bank = 'parametrization.read.bank',
  parametrization_create_bank = 'parametrization.create.bank',
  parametrization_update_bank = 'parametrization.update.bank',
  parametrization_delete_bank = 'parametrization.delete.bank',
}
